import {createSignal} from '@pexip/signal';

export const notificationPermissionSignal = createSignal({
    name: 'notification:permissionChange',
});
